import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    leftGrid: {
        textAlign: 'left',
        minWidth: '350px',
        maxWidth: '100%',
    },
    rightGrid: {
        minWidth: '350px',
        maxWidth: '100%',
        color: '#333',
    },
    motivationalTitle: {
        lineHeight: 1.4,
        fontWeight: 500,
        fontSize: '24px',
    },
    subTitle: {
        marginTop: '30px',
        fontSize: '16px',
        lineHeight: 1.4,
        fontWeight: 500,
    },
    hintLinkBtn: {
        fontSize: '12px',
        margin: '10px 10px 0',
        color: '#b7b5b5',
        fontFamily: 'Noto Sans JP, sans-serif',
        textDecoration: 'underline',

        "&:hover": {
            opacity: 0.7
        }
    },
    submit: {
        width: '140px',
        color: 'white',
        border: '1px solid white',
        boxShadow: 'none',
        padding: '6px 40px',
        margin: theme.spacing(3, 0, 3),
        "&:hover": {
            boxShadow: 'none',
            opacity: 0.7
        }
    },
    submitLoading: {
        width: '140px',
        color: 'white',
        border: '1px solid white',
        boxShadow: 'none',
        // padding: '6px 40px',
        margin: theme.spacing(3, 0, 3),
        opacity: 0.7,
        "&:hover": {
            backgroundColor:'#F3923D'
        }
    },
    submitCircularProgress: {
        color:'white',
        opacity: 0.5,
        // position: 'absolute',
        // top: '50%',
        // left: '50%',
        // marginTop: '-12px',
        // marginLeft: '-12px',
    },
    parentGridContainer: {
        borderRadius: 4,
        width: '800px',
        maxWidth: '100%',
        fontFamily: 'Noto Sans JP',
    },
}));